/*
  The real SHERIFF-AI system mark — geometry copied verbatim from
  assets/sheriff-icon.svg (octagonal shield + targeting reticle + sentinel
  core). Rendered as a static app icon: the gradient identity stays, but the
  neon drop-shadow filter, ambient glow disc, and pulse animation are gone —
  the mark sits quietly in the chrome like a product icon should.

  `uid` namespaces the gradient ids so several instances can coexist on one
  page without id collisions.
*/
export function SheriffLogo({
  size = 44,
  uid = "nav",
}: {
  size?: number;
  uid?: string;
}) {
  const g = `sh-grad-${uid}`;
  const tile = `sh-tile-${uid}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      role="img"
      aria-label="SHERIFF-AI EDR logo"
    >
      <defs>
        <linearGradient id={g} x1="40" y1="36" x2="216" y2="220" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1f6feb" />
          <stop offset="0.55" stopColor="#b70bf4" />
          <stop offset="1" stopColor="#d683ff" />
        </linearGradient>
        <linearGradient id={tile} x1="0" y1="0" x2="0" y2="256" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#150a22" />
          <stop offset="1" stopColor="#02000d" />
        </linearGradient>
      </defs>

      <rect width="256" height="256" rx="56" fill={`url(#${tile})`} />
      <rect x="3" y="3" width="250" height="250" rx="53" fill="none" stroke={`url(#${g})`} strokeOpacity="0.35" strokeWidth="2" />

      <polygon points="79,12 177,12 244,79 244,177 177,244 79,244 12,177 12,79" fill="none" stroke={`url(#${g})`} strokeWidth="11" strokeLinejoin="round" />
      <polygon points="90,38 166,38 218,90 218,166 166,218 90,218 38,166 38,90" fill="none" stroke={`url(#${g})`} strokeWidth="5" strokeOpacity="0.6" strokeLinejoin="round" />
      <g stroke={`url(#${g})`} strokeWidth="9" strokeLinecap="round">
        <line x1="128" y1="22" x2="128" y2="54" />
        <line x1="128" y1="202" x2="128" y2="234" />
        <line x1="22" y1="128" x2="54" y2="128" />
        <line x1="202" y1="128" x2="234" y2="128" />
      </g>
      <circle cx="128" cy="128" r="31" fill="none" stroke={`url(#${g})`} strokeWidth="9" />
      <circle cx="128" cy="128" r="12" fill={`url(#${g})`} />
    </svg>
  );
}
